import React from 'react';
import { TableColumnFormatter } from '@deephaven/jsapi-utils';
import CustomFormatAction from "./CustomFormatAction.js";
import { jsx as _jsx } from "react/jsx-runtime";
class FormatContextMenuUtils {
  /**
   * Returns true if default option should be active in the context menu
   * @param selectedFormat selected format object or null
   */
  static isDefaultSelected(selectedFormat) {
    return !selectedFormat || ![TableColumnFormatter.TYPE_CONTEXT_CUSTOM, TableColumnFormatter.TYPE_CONTEXT_PRESET].includes(selectedFormat.type);
  }

  /**
   * Returns true if custom format option should be active in the context menu
   * @param selectedFormat selected format object or null
   */
  static isCustomSelected(selectedFormat) {
    return selectedFormat != null && selectedFormat.type === TableColumnFormatter.TYPE_CONTEXT_CUSTOM;
  }

  /**
   * Creates context menu option
   * @param title Context menu title
   * @param format Format object
   * @param group Context menu group
   * @param isSelected Is current option selected
   */
  static makeOption(title, format, group, isSelected) {
    return {
      title,
      description: title,
      group,
      format,
      isSelected
    };
  }

  /**
   * Creates context menu option with an input element
   * @param format Format object
   * @param group Context menu group
   * @param placeholder Input element placeholder
   * @param isSelected Is current option selected
   * @param onChange Input element onChange callback
   */
  static makeCustomFormatOption(format, group, placeholder, isSelected, onChange) {
    var _format$formatString;
    return {
      title: format.label,
      description: format.label,
      format,
      group,
      isSelected,
      menuElement: /*#__PURE__*/_jsx(CustomFormatAction, {
        formatString: (_format$formatString = format.formatString) !== null && _format$formatString !== void 0 ? _format$formatString : undefined,
        title: format.label,
        placeholder: placeholder,
        onChange: onChange
      })
    };
  }
}
export default FormatContextMenuUtils;
//# sourceMappingURL=FormatContextMenuUtils.js.map